import React, { useState } from "react";
import { IconArrowLeft } from "@tabler/icons-react";
import { Anchor, Box, Button, Center, Container, Group, Paper, Text, TextInput, Title } from "@mantine/core";
import "./styles.scss";
import { Colors } from "../../lib/Data";
import { Link } from "react-router-dom";
import { useForm } from "@mantine/form";
import { DefaultErrorNotification, DefaultSuccessNotification, validateEmail } from "../../lib/Methods";
import { PerformRequest } from "../../lib/usePerformRequest";
import { Endpoints } from "../../lib/Endpoints";
import AnimateOnLoad from "../../components/AnimateOnLoad";

const ResetPassword: React.FC = () => {
  const resetForm = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: (value) => (validateEmail(value) ? null : "Enter a valid email"),
    },
  });

  const [isLoading, setLoading] = useState<boolean>(false);

  const RequestResetLink = async () => {
    const { hasErrors } = resetForm.validate();
    if (!hasErrors) {
      setLoading(true);
      const r = await PerformRequest({
        method: "GET",
        route: Endpoints.GetRequestResetLink(resetForm.values.email),
        callback: () => {
          setLoading(false);
        },
      });
      setLoading(false);
      if (r) {
        if (r.status === 404) {
          DefaultErrorNotification("Account does not exist!");
        }
        if (r.status === 200) {
          DefaultSuccessNotification("Link sent to your email");
        }
      }
    }
  };
  return (
    <AnimateOnLoad>
      <div className="reset-password-container flex-row">
        <div className="form">
          <Title className={"title"} ta="center">
            Forgot your password?
          </Title>
          <Text c="dimmed" fz="sm" ta="center">
            Enter your email to get a reset link
          </Text>

          <Paper withBorder shadow="md" p={20} radius="md" mt="xl">
            <TextInput {...resetForm.getInputProps("email")} label="Your email" placeholder="you@email.com" required />
            <Group justify="space-between" mt="lg" className={"controls"}>
              <Anchor c="dimmed" size="sm" className={"control"}>
                <Link to="/login">
                  <Center inline c="dimmed">
                    <IconArrowLeft size={12} stroke={1.5} />
                    <Box ml={5}>Back to Login</Box>
                  </Center>
                </Link>
              </Anchor>
              <Button color={Colors.GreenPrimary} onClick={RequestResetLink} className={"control"} loading={isLoading}>
                Reset password
              </Button>
            </Group>
          </Paper>
        </div>
      </div>
    </AnimateOnLoad>
  );
};
export default ResetPassword;
